<script lang="ts">
	//UI
	import ContainerLoading from "@hitit/hub/src/v7/components/common/ContainerLoading.svelte";
	//Utils
	import { api, store } from "@hitit/hub/src/stores";
	import { onDestroy } from "svelte";
	//Types
	//Props
	export let storeId = "";
	//Constants
	//Variables
	let error = false;
	let loading = true;
	//Functions
	//Do
	$: (async (originStoreId: string) => {
		try {
			loading = true;
			const response = await $api.getStore(originStoreId);
			if (storeId !== originStoreId) return;
			$store = response.data.result[0];
			error = false;
		} catch (e) {
			if (storeId !== originStoreId) return;
			error = true;
			$store = undefined;
		} finally {
			if (storeId !== originStoreId) return;
			loading = false;
		}
	})(storeId);

	onDestroy(() => ($store = undefined));

</script>

{#if loading}
	<ContainerLoading />
{/if}
<slot />

<style lang="scss">
</style>
